export const ENVIRONMENTS = {
    BETA: 'beta',
    BETA_PREVIEW: 'betapreview',
    DEVSPACE: 'devspace',
    NON_BETA: 'nonbeta',
    NON_BETA_PREVIEW: 'nonbetapreview',
    LIVE: 'live',
    LOCAL: 'local',
}

const URLS_FOR_TYPES = {
    event: '/events/programs',
    instance: '/events/performances',
    series: '/events/series',
    press: '/press/releases',
}

export function getEnvironment() {
    // BETA
    if (window.location.hostname.includes('frontstage.beta.basker.net')) {
        return ENVIRONMENTS.BETA;
    }

    if (window.location.hostname.includes('preview.beta.basker.net')) {
        return ENVIRONMENTS.BETA_PREVIEW;
    }

    // NON-BETA
    if (window.location.hostname.includes('mybasker.com')) {
        return ENVIRONMENTS.NON_BETA;
    }

    if (window.location.hostname.includes('baskerpreview.com')) {
        return ENVIRONMENTS.NON_BETA_PREVIEW;
    }

    // DEVSPACE
    if (window.location.hostname.includes('devspace.net')) {
        return ENVIRONMENTS.DEVSPACE;
    }

    // LIVE
    if (window.location.hostname.includes('.com')) {
        return ENVIRONMENTS.LIVE;
    }

    // FALLBACK
    return ENVIRONMENTS.LOCAL;
}

export function getCookieDomain() {
    const environment = getEnvironment();

    let host = window.location.hostname;

    if (environment === ENVIRONMENTS.DEVSPACE || environment === ENVIRONMENTS.LIVE) {
        const url = window.AppConfig?.blocksOfficeBaseUrl;

        if (url) {
            host = new URL(url).hostname;
        }
    }

    return host.replace(/^[^.]+/, '');
}

export function getAbsoluteUrl(object, type) {
    const environment = getEnvironment();
    let slug = 'laphil';
    let domain = '';

    if (object.tenant == '69a561892d693e86cdd3b28c' || object.tenant?.id == '69a561892d693e86cdd3b28c') {
        slug = 'hollywoodbowl';
    } else if (object.tenant == '69afec82275576cac82c8f48' || object.tenant?.id == '69afec82275576cac82c8f48') {
        slug = 'theford';
    }

    if (environment === ENVIRONMENTS.BETA) {
        domain = `https://${slug}.frontstage.beta.basker.net`;
    } else if (environment === ENVIRONMENTS.NON_BETA) {
        domain = `https://${slug}.mybasker.com`;
    } else if (environment === ENVIRONMENTS.DEVSPACE) {
        domain = `https://basker.${slug}.devspace.net`;
    } else if (environment === ENVIRONMENTS.LIVE) {
        domain = `https://www.${slug}.com`;
    }

    if (slug !== 'laphil' && type in URLS_FOR_TYPES) {
        const importId = parseInt(object.attributes?.custom?.import_id, 10);

        if (importId) {
            if (environment === ENVIRONMENTS.NON_BETA || environment === ENVIRONMENTS.LIVE) {
                return `https://www.${slug}.com${URLS_FOR_TYPES[type]}/${importId}`;
            }

            return `https://www.${slug}.devspace.net${URLS_FOR_TYPES[type]}/${importId}`;
        }
    }

    if (!object.url) {
        return null;
    }

    return `${domain}${object.url}`;
}

export default {
    ENVIRONMENTS,
    getEnvironment,
    getCookieDomain,
    getAbsoluteUrl,
}
